export function normalizePersonId(personId) {
  if (personId == null || personId === '') return '';
  if (typeof personId === 'object') {
    if (personId._id != null) return String(personId._id);
    if (typeof personId.toHexString === 'function') return personId.toHexString();
    const asString = String(personId);
    return asString === '[object Object]' ? '' : asString;
  }
  return String(personId);
}
